class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
      summary.setAttribute('aria-expanded', 'true');
    } else {
      this.animations.forEach((animation) => animation.cancel());
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Add hover event listeners
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.classList.add('sb-open');
  }

  onMouseLeave() {
    this.mainDetailsToggle.classList.remove('sb-open');
    // Timeout to allow a smooth transition
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
    }, 150);
  }

  onToggle() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open') ? 'true' : 'false');

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onKeyDown(event) {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (event.key === 'Escape' && isOpen) {
      event.preventDefault();
      this.close();
      summary.focus();
      return;
    }

    // Collect all focusable links/buttons inside the submenu (excluding summary contents)
    const allFocusable = [...this.mainDetailsToggle.querySelectorAll('a[href], button:not([disabled])')];
    const submenuLinks = allFocusable.filter((el) => !summary.contains(el));

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (summary === document.activeElement || summary.contains(document.activeElement)) {
        if (!isOpen) {
          this.mainDetailsToggle.setAttribute('open', '');
          this.mainDetailsToggle.classList.add('sb-open');
        }
        if (submenuLinks.length) submenuLinks[0].focus();
      } else {
        const currentIndex = submenuLinks.indexOf(document.activeElement);
        if (currentIndex !== -1 && currentIndex < submenuLinks.length - 1) {
          submenuLinks[currentIndex + 1].focus();
        }
      }
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      const currentIndex = submenuLinks.indexOf(document.activeElement);
      if (currentIndex > 0) {
        submenuLinks[currentIndex - 1].focus();
      } else if (currentIndex === 0) {
        summary.focus();
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
